<template>
  <div>
    <!-- <MyHeader /> -->
    <div class="detail">
      <nuxt-link to="/html/news/" class="goback">返回新闻动态</nuxt-link>
      <div class="title">{{ detail.title }}</div>
      <div class="date">
        {{ detail.date }}
        <span v-if="detail.from">来源：{{ detail.from }}</span>
        <a v-if="detail.fromUrl" :href="detail.fromUrl" target="_blank">查看原文</a>
      </div>
      <div class="content" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { getById } from "../../../../../data/news";

export default {
  asyncData({ params }) {
    return Promise.resolve(getById(params.id)).then((detail) =>
      detail.getContent().then((content) => ({
        detail,
        content,
      }))
    );
  },
  components: {},
  head() {
    return {
      title: this.detail && this.detail.title,
    };
  },
};
</script>

<style lang="less" scoped>
.detail {
  max-width: 760px;
  margin: 0 auto;
  padding: 0 48px/2;

  a.goback {
    margin-top: 80px;
    color: #1a1a1a;
    font-size: 14px;
    line-height: 16px;
    display: block;
    text-decoration: none;
    position: relative;
    padding-left: 24px;

    &:after {
      content: "";
      display: block;
      width: 16px;
      height: 16px;
      position: absolute;
      top: 0;
      left: 0;
      background-image: url(//img.souche.com/f2e/5ab25014e9f132ccad56fa17c13d6d52.png);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .title {
    margin-top: 36px;
    color: #1a1a1a;
    font-size: 32px;
    line-height: 40px;
    font-weight: bold;
  }

  .date {
    margin-top: 20px;
    color: #999999;
    font-size: 14px;
    line-height: 14px;

    span {
      margin-left: 16px;
    }

    a {
      color: #2ca8ff;
      margin-left: 16px;
    }
  }

  .content {
    margin-top: 48px;

    & /deep/ * {
      margin: 0;
      padding: 0;
    }

    & /deep/ img {
      // display: block;
      max-width: 100% !important;
      height: auto !important;
    }

    & /deep/ p {
      // margin: 20px 0;
      font-size: 16px;
      line-height: 18px;
      text-align: justify;
    }
  }
}

@media screen and (max-width: 540px) {
  .detail {
    a.goback {
      display: none;
    }

    .title {
      margin-top: 74px/2;
      font-size: 48px/2;
      line-height: 60px/2;
    }

    .date {
      margin-top: 26px/2;
      font-size: 24px/2;
      line-height: 24px/2;
    }

    .content {
      & /deep/ p {
        margin: 50px/2 0;
        line-height: 50px/2;
        text-align: justify;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/html/news/detail/_id.vue